<template>
    <div :class="preCls + 'content-box'">
        <loading-animation v-if="loading" />
        <div v-else>
            <div class="header">
                <div class="header-left">
                    <Icon
                        custom=" iconfont iconfont-daloujianzhu"
                        size="78"
                        class="header-left-icon"
                    ></Icon>
                </div>
                <div class="header-right">
                    <div class="title">
                        {{ info.entity.houseName }}
                        <tag-status
                            v-if="info.entity.contractStatusObj"
                            style="font-size: 14px"
                            :text="info.entity.contractStatusObj.text"
                            :color="info.entity.contractStatusObj.color"
                            :background="
                                info.entity.contractStatusObj.background
                            "
                            circle
                        />
                    </div>
                    <div class="text">
                        <div class="houseNum">
                            房号：{{ info.entity.houseNum }}
                        </div>
                        <div>房间代码：{{ info.entity.houseNo }}</div>
                    </div>
                </div>
            </div>
            <Tabs class="router-view" :animated="false" v-model="active">
                <TabPane
                    v-for="item in tabs"
                    :key="item.name"
                    :label="item.meta.title"
                    :name="item.name"
                >
                    <Access :name="item.name">
                        <router-view
                            v-if="active == item.name"
                            :name="item.meta.uri"
                            :info="info"
                            :isLiquidation="isLiquidation"
                            :relContractId="relContractId"
                            :contractId="info.contractCus.contractId"
                            :houseName="info.entity.houseName"
                            @refresh-detail="fetch"
                            @show-liquidation="onShowLiquidation"
                            @popCusTop="popCusTop"
                        />
                    </Access>
                </TabPane>
            </Tabs>
            <!-- 弹出层 -->
            <smart-modal
                v-model="modal.showChargeDetails"
                title="清算明细"
                :width="800"
                :height="600"
                :maskClosable="false"
            >
                <charge-details
                    v-if="modal.showChargeDetails"
                    :value="chargeDetails"
                    :remark="remark"
                    history
                />
            </smart-modal>
        </div>
    </div>
</template>
<script>
import mTab from '_v/common/m-tab'
import { formateLeaseReverse } from '_v/common/u-contract'
import mContract from '_v/common/m-contract'
import { mapCache } from '_g/vux-data-cache'
import Dict from '_u/dict'

import TagStatus from '_vc/tag-status'
import LoadingAnimation from '_vc/loading-animation'
import ChargeDetails from '_vc/charge-details'

import {
    contractView,
    relContract,
    contractLiquidationDetail,
} from '@/api/contract'

export default {
    mixins: [mTab, mContract],
    components: {
        TagStatus,
        LoadingAnimation,
        ChargeDetails,
    },
    data() {
        return {
            // state
            active: this.$cache.active,
            loading: false,
            remark: '', // 清算备注
            chargeDetails: [], // 清算明细
            // data
            info: {
                entity: {},
                facilityList: [],
                changeInfo: {},
                contractCus: {},
                contractLease: {},
            },
            relContractId: '', // 新合同id
            dict: {
                feeType: Dict.Null,
                payType: Dict.Null,
                contractStatus: Dict.NULL,
            },
            modal: {
                showChargeDetails: false,
            },
            routerContractId: this.$route.query.contractId, // 合同id
        }
    },
    computed: {
        ...mapCache({
            contractViewBill: 'contractViewBill',
        }),
        isLiquidation() {
            return this.checkLiquation(this.info.entity)
        },
    },
    created() {
        if (this.routerContractId) {
            this.contractViewBill.contractId = this.routerContractId
        }
        if (this.$route.query.tabItem) {
            this.active = this.$route.query.tabItem
        } else {
            this.active = 'contractViewDetail'
        }
        this.fetch()
    },
    methods: {
        fetch() {
            this.loading = true

            Promise.all([
                Dict.get(['contract_status', 'fee_type', 'pay_type']),
                contractView(this.routerContractId),
                relContract(this.routerContractId),
            ])
                .then((args) => {
                    var [dictGroup, view, rel] = args

                    Object.keys(this.dict).forEach((name) => {
                        this.dict[name] = dictGroup[name]
                    })
                    this.normalizeContract(view.data)
                    this.relContractId = rel.data.relContractId || ''
                })
                .finally(() => {
                    this.loading = false
                })
        },
        normalizeContract(info) {
            // 房间配置
            info.facilityList.forEach((v) => {
                v.parentId = v.pid
                v.price /= 100
            })
            // 合同状态
            const contractStatus = this.dict.contractStatus.get(
                info.entity.contractStatus
            )
            if (contractStatus) {
                contractStatus.remark = JSON.parse(contractStatus.remark)
                info.entity.contractStatusObj = {
                    text: contractStatus.text,
                    color: contractStatus.remark.color,
                    background: contractStatus.remark.background,
                }
            }
            // 租约信息
            info.contractLease.signUser = info.entity.signUser
            info.contractLease.agentUser = info.agentUser
            formateLeaseReverse(info.contractLease)
            info.contractLease.fList = info.facilityList
            //
            if (info.changeInfo) {
                info.changeInfo.changeDate = new Date(
                    info.changeInfo.changeDate
                )
            }
            // 租客信息
            Object.keys(info.contractCus).forEach((name) => {
                if (
                    info.contractCus[name] === undefined ||
                    info.contractCus[name] === null
                ) {
                    info.contractCus[name] = ''
                }
            })
            this.info = info
        },
        popCusTop() {
            console.log('popCusTop')
            this.fetch()
        },
        onShowLiquidation() {
            contractLiquidationDetail(this.routerContractId)
                .then((res) => {
                    const { remark, chargeDetails } = this.normalizeLiquidation(
                        res.data
                    )
                    this.remark = remark
                    this.chargeDetails = chargeDetails
                })
                .finally(() => {
                    this.modal.showChargeDetails = true
                })
        },
    },
}
</script>
<style lang="less" scoped>
.header {
    padding: 11px 0px;
    display: flex;
    &-left {
        &-icon {
            background: #f2f2f2;
            color: #dddddd;
            border-radius: 8px;
            margin-left: 30px;
        }
    }
    &-right {
        flex-grow: 1;
        margin-left: 12px;

        .title {
            font-size: 20px;
            color: #333333;
        }
        .text {
            font-size: 14px;
            color: #7f7f7f;
            margin-top: 10px;
            .houseNum {
                width: 120px;
            }
            div {
                display: inline-block;
            }
        }
    }
}
</style>
